import {compareDate, isValidDate} from '../../../common/utils/dateUtils'

interface RentalWithEnd {
  rentEnd?: string
}

/**
 * Returns the rental with the latest valid rentEnd.
 *
 * Performance note:
 * This is intentionally O(n) and avoids sorting, because it is called many times
 * when building actions data across boxes/compartments.
 */
export const getLatestRental = <T extends RentalWithEnd>(rentals: T[]): T | undefined => {
  let latest: T | undefined

  for (const rental of rentals) {
    if (!isValidDate(rental.rentEnd)) continue

    if (!latest) {
      latest = rental
      continue
    }

    // If rental is later than latest, update latest.
    if (compareDate(rental.rentEnd, latest.rentEnd, 'desc') < 0) {
      latest = rental
    }
  }

  return latest
}
